class CustomSliderComponent extends SliderComponent {
  constructor() {
    super();
    this.totalSlides = parseInt(this.dataset.totalSlides) || 1;
    if (this.pageTotalElement) {
      this.pageTotalElement.textContent = this.totalSlides;
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.totalSlides;
    this.update();
  }
}

customElements.define('slider-component', CustomSliderComponent); 